// Itens do menu do portal (Gestão da equipe / Financeiro) → caminho dentro da Central (/ordens/*).
// Fica separado da Central para o Shell não carregar o código dela só para montar o menu.

const mesAtual = () => new Intl.DateTimeFormat('sv-SE', { timeZone: 'America/Sao_Paulo', year: 'numeric', month: '2-digit' }).format(new Date());

export const CENTRAL_ORDENS_PATHS: Record<string, string | (() => string)> = {
  'central-ordens': '/ordens',
  'central-ordens-pessoas': '/ordens/pessoas',
  'central-ordens-projetos': '/ordens/projetos',
  'central-ordens-reunioes': '/ordens/reunioes',
  'central-ordens-equipe': '/ordens/equipe',
  'central-ordens-nova': '/ordens/ordens/nova',
  'financeiro': '/ordens/financeiro',
  'financeiro-mes': () => `/ordens/financeiro/${mesAtual()}`,
  'financeiro-despesas': '/ordens/financeiro/despesas',
  'financeiro-regras': '/ordens/financeiro/regras',
  'central-ordens-minhas': '/ordens/minhas',
  'central-ordens-setores': '/ordens/setores',
  'central-ordens-todas': '/ordens/ordens',
  'central-ordens-agenda': '/ordens/agenda',
  'central-ordens-calendario': '/ordens/calendario',
  'central-ordens-lembretes': '/ordens/config/lembretes',
};

/** Caminho da Central para um item do menu (null se o item não é da Central). */
export function centralPath(page: string): string | null {
  const t = CENTRAL_ORDENS_PATHS[page];
  return t === undefined ? null : typeof t === 'function' ? t() : t;
}

/** Item do menu correspondente ao caminho atual (/ordens/...), para destacar a categoria no menu. */
export function centralPageFor(pathname: string): string | null {
  if (pathname !== '/ordens' && !pathname.startsWith('/ordens/')) return null;
  if (/^\/ordens\/financeiro\/\d{4}-\d{2}/.test(pathname)) return 'financeiro-mes';
  let best: string | null = null, len = -1;
  for (const [page, t] of Object.entries(CENTRAL_ORDENS_PATHS)) {
    if (typeof t !== 'string') continue;
    if ((pathname === t || pathname.startsWith(t + '/')) && t.length > len) { best = page; len = t.length; }
  }
  return best;
}
